import { useFieldValue } from "components/form/input/NestedField";
import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import { useEffect, useMemo } from "react";
import FormRow from "components/form/FormRow";
import DateInput from "components/form/input/DateInput";

import IPSP from "..";
import { useForm } from "react-final-form";

export default function EditFields({ visita, TipoClass }) {
    const [tipo, setTipo] = useTipoApontamento();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const params = useMemo(() => visita.cliente.getParams(IPSP, "Mecanizado", TipoClass), [visita.cliente])

    const [apontamento, setApontamento] = useFieldValue();
    const form = useForm()

    useEffect(() => {
        if (tipo !== "Mecanizado") {
            setTipo("Mecanizado")
        }
    }, [setTipo, tipo])

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = IPSP.calcConformidade(apontamento, params, setApontamento);
            form.change("conformidade", IPSP.calcConformidade(apontamento, params, setApontamento))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params]);

    return (
        <>
            <ApontamentoCommonFields visita={visita} showImplemento={false} />

            <ApontamentoAmostraParams tipoFixedValue="Mecanizado">
                <FormRow>
                    <DateInput name="dataPreparoSolo" label="Data Preparo de Solo" required />
                </FormRow>

                <FormRow>
                    <DateInput name="dataInicioPlantio" label="Data Início Plantio" required />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="Meta (Dias):">{params.meta}</ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoResultado conformidadeLabel="Intervalo de Dias"></ApontamentoResultado>

            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
